
export default class CovidConfiguration {
    reminderAlarm1=""
    reminderAlarm2=""
    notificationEmailAlarm1=""
    notificationEmailAlarm2=""
    notificationEmailAlarm3=""
    notificationEmailAlarm4=""
    notificationEmailAlarm5=""
    notificationEmailAlarm6=""
    notificationEmailAlarm7=""
    notificationEmailAlarm8=""
    notificationEmailAlarm9=""
    notificationEmailAlarm10=""
    notificationEmailAlarm11=""
    notificationEmailAlarm12=""
    notificationEmailAlarm13=""
    notificationEmailAlarm14=""
    notificationEmailAlarm15=""
    notificationEmailAlarm16=""
    notificationEmailAlarm17=""
    notificationEmailAlarm18=""
    notificationEmailAlarm19=""
    notificationEmailAlarm20=""
    notificationEmailAlarm21=""
    notificationEmailAlarm22=""
    notificationEmailAlarm23=""
    notificationEmailAlarm24=""
    notificationEmailAlarm25=""
    notificationEmailAlarm26=""
    notificationEmailAlarm27=""
    notificationEmailAlarm28=""
    notificationEmailAlarm29=""
    notificationEmailAlarm30=""
    notificationEmailAlarm31=""
    notificationEmailAlarm32=""
    notificationEmailAlarm33=""
    notificationEmailAlarm34=""
    notificationEmailAlarm35=""
    notificationEmailAlarm36=""
    notificationEmailAlarm37=""
    notificationEmailAlarm38=""
    notificationEmailAlarm39=""
    notificationEmailAlarm40=""
    notificationEmailAlarm41=""
    notificationEmailAlarm42=""
    notificationEmailAlarm43=""
    notificationEmailAlarm44=""
    notificationEmailAlarm45=""
    notificationEmailAlarm46=""
    notificationEmailAlarm47=""
    notificationEmailAlarm48=""
    notificationEmailAlarm49=""
    notificationEmailAlarm50=""
    companyAlarm1={id:""}
    companyAlarm2={id:""}
    companyAlarm3={id:""}
    companyAlarm4={id:""}
    companyAlarm5={id:""}
    companyAlarm6={id:""}
    companyAlarm7={id:""}
    companyAlarm8={id:""}
    companyAlarm9={id:""}
    companyAlarm10={id:""}
    companyAlarm11={id:""}
    companyAlarm12={id:""}
    companyAlarm13={id:""}
    companyAlarm14={id:""}
    companyAlarm15={id:""}
    companyAlarm16={id:""}
    companyAlarm17={id:""}
    companyAlarm18={id:""}
    companyAlarm19={id:""}
    companyAlarm20={id:""}
    companyAlarm21={id:""}
    companyAlarm22={id:""}
    companyAlarm23={id:""}
    companyAlarm24={id:""}
    companyAlarm25={id:""}
    companyAlarm26={id:""}
    companyAlarm27={id:""}
    companyAlarm28={id:""}
    companyAlarm29={id:""}
    companyAlarm30={id:""}
    companyAlarm31={id:""}
    companyAlarm32={id:""}
    companyAlarm33={id:""}
    companyAlarm34={id:""}
    companyAlarm35={id:""}
    companyAlarm36={id:""}
    companyAlarm37={id:""}
    companyAlarm38={id:""}
    companyAlarm39={id:""}
    companyAlarm40={id:""}
    companyAlarm41={id:""}
    companyAlarm42={id:""}
    companyAlarm43={id:""}
    companyAlarm44={id:""}
    companyAlarm45={id:""}
    companyAlarm46={id:""}
    companyAlarm47={id:""}
    companyAlarm48={id:""}
    companyAlarm49={id:""}
    companyAlarm50={id:""}
    encryptReport=""
}


// WEBPACK FOOTER //
// ./src/model/CovidConfiguration.js